export const  formatName = (name) => {
    if (!name) return "";
    return name
      .toLowerCase()
      .trim() // Remove leading/trailing whitespace
      .split(/\s+/) // Split by any whitespace (handles spaces, tabs, enters)
      .map(word => {
        if (word.startsWith("mc") && word.length > 2) {
          return "Mc" + word.charAt(2).toUpperCase() + word.slice(3);
        } else if (word.startsWith("de") && word.length > 2) {
          return "De" + word.charAt(2).toUpperCase() + word.slice(3);
        } else if (word.startsWith("o'") && word.length > 2) {
          return "O'" + word.charAt(2).toUpperCase() + word.slice(3);
        } else {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }
      })
      .join(" ");
  }